<template>
  <v-app class="grey light-4">
    <PyNavBar v-if="this.$route.meta.navbar"/>
    <v-content>
      <router-view></router-view>
    </v-content>
    <notifications 
    group="success"
    classes="vue-notification success"
    position="bottom right"
    />
    <notifications 
    group="error"
    classes="vue-notification error"
    position="bottom right"
    />
    <notifications 
    group="warning"
    classes="vue-notification warn"
    position="bottom right"
    />
  </v-app>
</template>

<script>

import PyNavBar from '@/components/layouts/PyNavBar'

export default {
  name: "App",
  components:{
    PyNavBar,
  },
  data: () => ({
    //
  })
};
</script>

<style>
  .v-data-table tbody td {
    font-size: 12px !important;
  }
</style>
